module.exports = __webpack_public_path__ + "static/media/asignatura7.fd459601.png";